import { render, staticRenderFns } from "./EndView.vue?vue&type=template&id=164bd014"
import script from "./EndView.vue?vue&type=script&lang=js"
export * from "./EndView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports